import { PropType } from 'vue';
import BaseListItemSetupService, { DetailPrefixForRouter } from '@/setup/BaseListItemSetupService';
import TempWorkerListItemEntity from '@/entity/temp-worker/TempWorkerListItemEntity';

type Props = SetupProps<typeof BaseTempWorkerEntitySetupService.props>

export default abstract class BaseTempWorkerEntitySetupService<P> extends BaseListItemSetupService<Props & P> {
	protected detailPrefixForRouter = DetailPrefixForRouter.TempWorker;

	static readonly props = {
		...BaseListItemSetupService.props,
		tempWorker: {
			type: Object as PropType<TempWorkerListItemEntity>,
			required: true as const,
		},
	};

	protected get itemId () { return this.props.tempWorker.id; }
	protected get tempWorker () { return this.props.tempWorker; }


	constructor (props: Props & P) {
		super(props);
	}
}
